import type { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { DirectorySearchType } from 'owa-recipient-types/lib/types/FindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setIsSuggesting')(function setIsSuggesting(
    viewState: AtMentionsViewState,
    isSuggesting: boolean,
    queryString: string = ''
) {
    viewState.isSuggesting = isSuggesting;

    if (!isSuggesting) {
        // Reset the viewState
        viewState.queryString = '';
        viewState.isSearching = false;
        viewState.directorySearchType = DirectorySearchType.None;
    }
});
